import { useQuery } from '@tanstack/react-query'
import { api } from '@/lib/api'

export interface StylePreset {
  id: string
  name: string
  description: string
  nameI18n?: Record<string, string> | null
  descriptionI18n?: Record<string, string> | null
  thumbnail: string
  updatedAt: string
}

export function useStyles() {
  return useQuery({
    queryKey: ['styles'],
    queryFn: () => api.get<StylePreset[]>('/generate/styles'),
    staleTime: 1000 * 60 * 60,
  })
}
